module.exports = __webpack_public_path__ + "src/assets/textures/env/windmill/windmill_parts_256_bake.png";